import React, { useEffect } from "react";
import { useForm } from "react-hook-form";
import { Form, Modal, ModalBody } from "reactstrap";
import { Button, Col, Icon } from "../../../../components/Component";

const EditCurrencyModal = ({ modal, closeModal, onSubmit, formData, setFormData, oldAmount }) => {
  const {
    reset,
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({ defaultValues: { fabstouchRate: "" } });

  useEffect(() => {
    reset(formData);
  }, [formData, reset]);

  return (
    <Modal isOpen={modal} toggle={() => closeModal()} className="modal-dialog-centered" size="lg">
      <ModalBody>
        <a
          href="#cancel"
          onClick={(ev) => {
            ev.preventDefault();
            closeModal();
          }}
          className="close"
        >
          <Icon name="cross-sm"></Icon>
        </a>
        <div className="p-2">
          <h5 className="title">Edit Exchange Rate</h5>
          <div className="mt-4">
            <Form className="row gy-4" noValidate onSubmit={handleSubmit(onSubmit)}>
              <Col md="6">
                <div className="form-group">
                  <label className="form-label">Live Naria Rate</label>
                  <div className="form-control-wrap">
                    <input className="form-control" disabled type="number" defaultValue={oldAmount} />
                  </div>
                </div>
              </Col>

              <Col md="6">
                <div className="form-group">
                  <label className="form-label">New Rate</label>
                  <input
                    className="form-control"
                    type="number"
                    {...register("fabstouchRate", { required: "This field is required" })}
                    defaultValue={formData.fabstouchRate}
                    onChange={(e) => setFormData({ ...formData, fabstouchRate: e.target.value })}
                  />

                  {errors.exchangeRate && <span className="invalid">{errors.exchangeRate.message}</span>}
                </div>
              </Col>
              <Col size="12">
                <ul className="align-center flex-wrap flex-sm-nowrap gx-4 gy-2">
                  <li>
                    <Button color="primary" size="md" type="submit">
                      Update Rate
                    </Button>
                  </li>
                  <li>
                    <a
                      href="#cancel"
                      onClick={(ev) => {
                        ev.preventDefault();
                        closeModal();
                      }}
                      className="link link-light"
                    >
                      Cancel
                    </a>
                  </li>
                </ul>
              </Col>
            </Form>
          </div>
        </div>
      </ModalBody>
    </Modal>
  );
};
export default EditCurrencyModal;
